export const permissions =  {
    Site: "Site",
    Cer: "Cer",
    Admin: "Admin",
    Intrapresa: "Intrapresa"
}